import axios from 'axios'

axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'https://spiderman.afrihost.com/gwenisthebest/';

export default {

    post(url, request) {
        return axios.post(url, request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject({
                status: error.response.status,
                data: error.response.data
            }));
    },

    setToken(token) {
        axios.defaults.headers.common = {
            'crossDomain': true,
            'Access-Control-Allow-Origin': '*',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': token
        };
    },

	setBaseUrl(base) {
		axios.defaults.baseURL = base
	},

    get(url, params) {

        return axios.get(url, {
                params: params
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject({
                status: error.response.status,
                data: error.response.data
            }));
    }
}
